import type { AuthorizationProvider } from './authorization-provider';
import type { CognitoAuthProviderDependencies, CognitoAuthProviderOptions } from './cognito';
import { createCognitoAuthorizationProvider } from './cognito';

type CreateAuthorizationProviderOptions = CognitoAuthProviderOptions;

type CreateAuthorizationProviderDependencies = Pick<
    CognitoAuthProviderDependencies,
    'apiBaseUrl' | 'clock' | 'logger' | 'validatingHttpFetcher'
>;

export const createAuthorizationProvider = (
    dependencies: CreateAuthorizationProviderDependencies,
    options: CreateAuthorizationProviderOptions,
): Promise<AuthorizationProvider> => {
    return createCognitoAuthorizationProvider(
        {
            apiBaseUrl: dependencies.apiBaseUrl,
            clock: dependencies.clock,
            createUuid() {
                return globalThis.crypto.randomUUID();
            },
            history: globalThis.history,
            location: globalThis.location,
            logger: dependencies.logger,
            storage: globalThis.localStorage,
            validatingHttpFetcher: dependencies.validatingHttpFetcher,
        },
        options,
    );
};
